import dayjs from "dayjs";
import AppContext from "../../../../application/AppContext";
import BaseUtil from "../../../../util/BaseUtil";
import {ListType} from "../../../../view/medigroup/medigroupmgmt/management/ListTypeRadioGroup";

const type = `@@ActionType/UPDATE@${__filename}`;

export const DocTeamUserChangeType = {
    ADD: {
        key: "ADD",
        name: "添加",
    },
    DELETE: {
        key: "DELETE",
        name: "删除",
    },
};

export const TabType = {
    UNIT_BASIC_INFO: {
        key: "UNIT_BASIC_INFO",
        name: "科室基本信息",
    },
    UNIT_MEMBER: {
        key: "UNIT_MEMBER",
        name: "科室成员",
    },
    MEDI_GROUP_MGMT: {
        key: "MEDI_GROUP_MGMT",
        name: "科室医疗组管理",
    },
};


const initState = {
    selectedUnitIds: [],
    selectedTab: TabType.UNIT_BASIC_INFO.key,
    addDocTeamModalVisible: false,
    listType: ListType.card,
    docTeamDetailViewVisible: false,
    userSelectVisible: false,
    month: dayjs(),
    currentDataMonth: dayjs(),
    loadingCount: 0,
    unitMember: [],
    applyDrawerPageable: {
        currentPage: 1,
        pageSize: 20,
    },
    pageable: {
        currentPage: 1,
        pageSize: 100,
    },
    removeCheckedUsers: [],
};

const [
    viewModel,
    update, reset,
] = BaseUtil.getViewModel(initState, type);

export {
    update, reset,
};

export default viewModel;
